import { AuthStep } from 'ui/types';

export const ALL_FEATURES: readonly AuthStep[] = [
  'forgot-password',
  'login',
  'reset-password',
  'sign-up',
];
